var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TrackingLogList',{attrs:{"sms-campaign-id":_vm.smsCampaign.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }